<template>
  <div>
    <v-row justify="center" class="pt-4 pb-12 pl-sm-4 pr-sm-4" no-gutters>
      <v-col xl="10" lg="11" md="12" sm="12" cols="10">
        <v-card outlined>
          <v-row no-gutters>
            <v-col xl="8" lg="8" md="7" sm="8" cols="8" class="card-border-right pb-12">
              <v-carousel class="images-carousel"
                :value="getSelectedImageIndex"
                height="440"
                delimiter-icon="mdi-minus"
                hide-delimiter-background
                :show-arrows="getProductImages.length > 0"
                :show-arrows-on-hover="getProductImages.length > 0"
                :hide-delimiters="getProductImages.length === 0"
                light>

                <v-carousel-item v-for="(image, i) in getProductImages" :key="'image_' + i">
                  <v-sheet height="100%" color="white">
                    <v-row class="fill-height" align="center" justify="center">
                      <v-img class="center-image" contain max-height="430" max-width="458" :src="image"></v-img>
                    </v-row>
                  </v-sheet>
                </v-carousel-item>
              </v-carousel>

              <v-row no-gutters>
                <v-col cols="12" align="left" class="pt-10 px-8 card-border-top">
                  <div class="pr-8 characteristics-title">Características</div>
                </v-col>
                <v-col cols="6" align="left" class="pt-5 px-4">
                  <v-list-item two-line>
                    <v-list-item-content>
                      <v-list-item-title>Codigo</v-list-item-title>
                      <v-list-item-subtitle>{{ _product.bar_code }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-col>
                <v-col cols="6" align="left" class="pt-5 px-4" v-if="_product.brand != '-'">
                  <v-list-item two-line>
                    <v-list-item-content>
                      <v-list-item-title>Marca</v-list-item-title>
                      <v-list-item-subtitle>{{ _product.brand }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-col>
                <v-col cols="6" align="left" :class="_product.brand == '-' ? 'pt-5 px-4' : 'px-4'" v-if="_product.manufacturer != '-'">
                  <v-list-item two-line>
                    <v-list-item-content>
                      <v-list-item-title>Fabricante</v-list-item-title>
                      <v-list-item-subtitle>{{ _product.manufacturer }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-col>
                <!-- <v-col cols="6" align="left"
                  :class="_product.brand == '-' && _product.manufacturer == '-' ? 'pt-5 px-4' : 'px-4'">
                  <v-list-item two-line>
                    <v-list-item-content>
                      <v-list-item-title>Duración</v-list-item-title>
                      <v-list-item-subtitle>{{ _product.Duracion }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-col> -->
                <v-col cols="12" align="left" class="pt-8 px-8" v-if="_product.description">
                  <div class="characteristics-title">Descripción</div>
                  <p class="mt-2 grey--text text--darken-2 subtitle-2">{{ _product.description }}</p>
                </v-col>
                <v-col cols="12" align="left" class="pt-5 px-8" v-if="_product.uses_and_care">
                  <div class="characteristics-title">Detalles y cuidados</div>
                  <p class="mt-2 grey--text text--darken-2 subtitle-2">{{ _product.uses_and_care }}</p>
                </v-col>
              </v-row>
            </v-col>

            <v-col class="text-left pt-7 pb-12" xl="4" lg="4" md="5" sm="4" cols="4">
              <div class="px-8">
                <div class="text--secondary mb-3 light-text">
                  Producto disponible
                </div>
                <div class="product-title">{{ _product.name }}</div>
                <div class="pt-1  price-text">{{ getProductPrice }}</div>
                <div class="pr-8">
                  <v-list two-line>
                    <v-list-item class="mt-n2 ml-n4">
                      <v-list-item-content>
                        <v-list-item-title class="payment-text">
                          <v-icon class="grey--text text--darken-4 pr-3" size="20">credit_card</v-icon>
                          <span class="grey--text text--darken-4">Paga con tarjeta de credito</span>
                        </v-list-item-title>
                        <v-list-item-subtitle class="text--secondary light-text pl-8">Hasta 48 cuotas</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item class="mt-n2 ml-n4">
                      <v-list-item-content>
                        <v-list-item-title class="payment-text">
                          <v-icon class="grey--text text--darken-4 pr-3" size="20">account_balance</v-icon>
                          <span class="grey--text text--darken-4">Transferencia bancaria</span>
                        </v-list-item-title>
                        <v-list-item-subtitle class="text--secondary light-text pl-8">Paga desde cualquier banco</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item class="mt-n2 ml-n4" three-line>
                      <v-list-item-content>
                        <v-list-item-title class="payment-text">
                          <v-icon class="grey--text text--darken-4 pr-3" size="20">local_shipping</v-icon>
                          <span class="grey--text text--darken-4" v-if="shippingInfo">
                            <span class="green--text text--darken-2" v-if="shippingInfo.cost === 0">Envío gratis</span>
                            <span v-else>Envío {{currency(shippingInfo.cost)}}</span>
                          </span>
                          <span class="grey--text text--darken-4" v-else>Envío a nivel nacional</span>
                        </v-list-item-title>
                        <v-list-item-subtitle class="text--secondary light-text pl-8">
                          <span class="grey--text text--darken-4" v-if="shippingInfo">
                            <span class="green--text text--darken-4" v-if="shippingInfo.cost === 0">Llega el {{ dateFormat(shippingInfo.delivery_date, 'D MMM YYYY') }}</span>
                            <span v-else>Llega el {{ dateFormat(shippingInfo.delivery_date, 'D MMM YYYY') }}</span>
                          </span>
                          <span class="grey--text text--darken-4" v-else>Envío rapido y seguro</span>
                        </v-list-item-subtitle>
                        <v-list-item-subtitle class="text--secondary light-text pl-8 pt-1">
                          <a class="blue--text text--darken-3" @click="checkShipping" v-if="shippingInfo">Modificar envío</a>
                          <a class="blue--text text--darken-3" @click="checkShipping" v-else>Calcular envío</a>
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </div>
                <v-form ref="form" v-model="valid">
                  <div class="mt-2" v-if="!!_product.variation_theme">
                    <v-select v-if="!_product.requires_formula"
                      v-model="variant"
                      :items="_product.variants"
                      item-text="name"
                      :label="getProductVariantConfig.name"
                      :rules="[isRequired]"
                      :hint="getProductVariantConfig.hint"
                      @change="changeVariant"
                      persistent-hint
                      filled
                      dense
                      return-object>
                    </v-select>
                    <div class="mt-n3 mb-4 quantity" v-else>
                      {{ getProductVariantConfig.hint }}:
                      <span class="grey--text text--darken-1" v-for="(variant, index) in _product.variants" :key="'product_variant_'+index">
                        <span v-if="index === 0">{{ variant.name }}</span>
                        <span v-else>, {{ variant.name }}</span>
                      </span>
                    </div>
                  </div>
                  <div class="mt-2">
                    <v-select v-if="!_product.requires_formula"
                      v-model.number="quantity"
                      :items="getProductQuantities"
                      item-text="value"
                      item-value="quantity"
                      label="Cantidad"
                      :rules="[isRequired, isNumeric]"
                      :hint="getQuantityHint"
                      :disabled="getProductQuantities.length === 0"
                      persistent-hint
                      filled
                      dense>
                    </v-select>
                    <div class="mt-n2 quantity" v-else>
                      {{ getTotalQuantities }}
                      <span v-if="getTotalQuantities === 1">Unidad disponible</span>
                      <span v-else>Unidades disponibles</span>
                    </div>
                  </div>
                  <div class="mt-5 mb-4">
                    <v-btn v-if="!_product.requires_formula" class="text-none" block height="48" color="blue darken-1" elevation="0" dark @click="addToCart()">
                      Añadir al carrito
                    </v-btn>
                    <v-btn v-else class="text-none" block height="48" color="blue darken-1" elevation="0" dark @click="selectFormula">
                      Seleccionar fórmula
                      <span class="text-lowercase" v-if="!!_product.variation_theme">&nbsp;y {{getProductVariantConfig.name}}</span>
                    </v-btn>
                  </div>
                </v-form>
              </div>

              <v-row class="mt-8" no-gutters>
                <v-col cols="12" class="card-border-top px-8 pt-8">
                  <div class="pr-8 section-title">Información sobre la tienda</div>
                  <v-list class="mt-2" two-line>
                    <v-list-item-content>
                      <v-list-item-title class="payment-text">
                        <v-icon class="grey--text text--darken-1 pr-3" size="20">location_on</v-icon>
                        <span class="grey--text text--darken-4">{{ ubication.departament }}</span>
                      </v-list-item-title>
                      <v-list-item-subtitle class="text--secondary light-text pl-8">Santiago de {{ ubication.city }}</v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-content>
                      <v-list-item-title class="payment-text">
                        <v-icon class="grey--text text--darken-1 pr-3" size="20">stay_current_portrait</v-icon>
                        <span class="grey--text text--darken-4">Teléfonos</span>
                      </v-list-item-title>
                      <v-list-item-subtitle class="text--secondary light-text pl-8">{{phone.cell_phone}}, {{ phone.landline }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list>
                  <div class="pl-1">
                    <a class="blue--text text--darken-3 link" @click="goToNewTab('About')">Ver mas datos de la tienda</a>
                  </div>
                </v-col>
              </v-row>
              <v-row class="mt-8" no-gutters>
                <v-col cols="12" class="card-border-top px-8 pt-8">
                  <div class="pr-8 section-title">Garantía</div>
                  <div class="mt-6 payment-text">
                    <span class="grey--text text--darken-4">Garantía del sitio hasta {{ daysWarranty }} dias</span>
                  </div>
                  <div class="text--secondary light-text">
                    Recibe el producto que esperabas o te devolvemos tu dinero
                  </div>
                  <div class="mt-4">
                    <a class="blue--text text--darken-3 link" @click="goToNewTab('Terms-conditions')">Conocer más sobre garantía</a>
                  </div>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
    <shipping-modal ref="shipping" :totalValue="getProductMinPrice"></shipping-modal>
    <formula-modal ref="formula" @selectedFormula="addToCart"></formula-modal>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex'
import { currency, dateFormat } from '@/shared/format'
import { isRequired, isNumeric } from '@/shared/validations'
import { cloneObject } from '@/shared/clone'
import { buildFormulaData } from '@/shared/formula'
import navigationMixin from '@/mixins/navigation'
import ShippingModal from '@/components/Shipping/ShippingModal'
import FormulaModal from '@/components/Formula/FormulaModal'
import { UBICATION, PHONE, DAYS_WARRANTY } from '@/config/local-info'

export default {
  name: 'ProductDetailDesk',
  mixins: [navigationMixin],
  components: {
    ShippingModal,
    FormulaModal
  },
  data () {
    return {
      currency,
      dateFormat,
      isRequired,
      isNumeric,
      quantity: 1,
      variant: null,
      ubication: UBICATION,
      phone: PHONE,
      daysWarranty: DAYS_WARRANTY,
      valid: true
    }
  },
  computed: {
    ...mapState('product', ['_product']),
    ...mapState('shipping', ['shippingInfo']),
    ...mapGetters('product', ['getProductImages', 'getSelectedImageIndex', 'getProductPrice', 'getProductMinPrice', 'getProductVariantConfig', 'getTotalQuantities', 'getProductQuantities']),
    getQuantityHint () {
      const quantity = this.getProductQuantities.length
      if (!quantity) {
        return this.getProductVariantConfig.hint_disabled_quantity
      }

      return quantity === 1 ? quantity + ' Unidad disponible' : quantity + ' Unidades disponibles'
    }
  },
  methods: {
    ...mapMutations('product', ['setVariant']),
    checkShipping () {
      this.$refs.shipping.openModal()
    },
    selectFormula () {
      this.$refs.formula.openModal()
    },
    changeVariant (variant) {
      this.setVariant(variant)
    },
    addToCart (data = undefined) {
      if (!this.$refs.form.validate()) {
        return
      }

      const product = cloneObject(this._product)

      if (!data) {
        product.quantity = this.quantity
        product.variant = this.variant

        this.$emit('add', [product])
        return
      }

      if (data.type === 'single') {
        product.formula = buildFormulaData(data.formula.left)
        product.quantity = data.quantity.left
        product.variant = data.variant

        this.$emit('add', [product])
        return
      }

      this.addMultipleToCart(data)
    },
    addMultipleToCart (data) {
      const productLeft = cloneObject(this._product)
      const productRight = cloneObject(this._product)

      // add left eye formula
      productLeft.quantity = data.quantity.left
      productLeft.variant = data.variant
      productLeft.formula = buildFormulaData(data.formula.left)

      // add right eye formula
      productRight.quantity = data.quantity.right
      productRight.variant = data.variant
      productRight.formula = buildFormulaData(data.formula.right)

      this.$emit('add', [productLeft, productRight])
    }
  }
}
</script>

<style scoped>
  .product-title{
    font-size: 1.625em;
    line-height: 1.230769230773em;
    font-weight: 600;
    color: #333333;
  }

  .characteristics-title{
    font-size: 1.5em;
    line-height: 1.230769230773em;
    font-weight: 600;
    color: #333333;
  }

  .light-text{
    font-size: 0.875em;
    color: #666;
    opacity: 0.7;
  }

  .price-text{
    font-size: 36px;
    color: #333333;
  }

  .center-image{
    margin: 0 auto;
  }

  .payment-text{
    font-size:0.9375em;
  }

  .link{
    font-size: 0.875em;
  }

  .quantity {
    font-weight: 500;
    color: #333333;
    font-size: 0.875em;
  }

  .images-carousel >>> .v-window__next {
    background: transparent;
  }

  .images-carousel >>> .v-window__prev {
    background: transparent;
  }
</style>
